import {useEffect} from 'react'

import {dispatch, useSelector} from '../../store.js'
import {STOCKTAKE_LIST_PAGE} from '../../common/constants/Pages.js'
import {STOCKTAKE_URI_COMPONENT} from '../../common/constants/Stocktakes.js'
import {setCurrentPage} from '../../redux/actions/ui/index.js'
import {locationSelector} from '../../redux/selectors/ui/location.js'
import {setupStocktakeListForm} from './stocktakeListFunctions.js'

export default function StocktakeListLocationListener() {
  const {
    pathComponents: [resource, referenceID],
  } = useSelector(locationSelector)
  const isThisPage = resource === STOCKTAKE_URI_COMPONENT && !referenceID

  useEffect(() => {
    setupStocktakeListForm()
  }, [])

  useEffect(() => {
    if (!isThisPage) {
      return
    }

    dispatch(setCurrentPage(STOCKTAKE_LIST_PAGE))
  }, [isThisPage])

  return null
}
